<template>
    <div class="o-m-languages m-languages">
        <div class="m-header__line"/>
        <button
            role="button"
            class="m-languages__button"
            v-for="(button, index) in languages"
            :key="index"
            @click="handleChangeLocale(button)"
        >
            <svg-icon
                original
                :name="`locales/${button}`"
                class="m-languages__icon"
            />
            <span class="m-languages__title">
                {{ $t(`ui.language-${button}`) }}
            </span>
        </button>
    </div>
</template>

<script>
import { mapActions, mapState} from 'vuex';
    
export default {
    name: 'OMLanguages',
    computed: {
        ...mapState({
            languages: state => state.map.meta.languages
        })
    },
    methods: {
        ...mapActions([
            'changeLocale'
        ]),
        handleChangeLocale(locale) {
            this.$emit('localeChanged', true);
            this.changeLocale(locale);
        }
    }
}
</script>

<style lang="scss">
@import "o-m-languages";
</style>